<!-- 
  详情页 - 销售机会
  props:
    id: 详情id
 -->

<template>
	<div class="sale-opportunity">
		<ul>
      <li class="item" v-for="item in listData">
        <h2 class="title"><a href="javascript:;" @click="openDetail(item.id)">{{item.name}}</a></h2>
        <div class="desc">
          <span class="text">负责人：{{item.manager}}</span>
          <span class="text">预计金额：{{item.estimateAmount}}</span>
          <span class="text">预计结束日期：{{item.estimateTime}}</span>
        </div>
        <span class="status">状态：{{item.saleStage}}</span>
      </li>
      <li class="item center" v-if="!listData.length">暂无数据</li>
    </ul>

    <div class="load-more">
      <template v-if="showLoadmore">
        <i class="el-icon-loading"></i>
        加载更多
      </template>
      <template v-if="!showLoadmore && page.total>page.size">没有更多</template>
    </div>
	</div>
</template>

<script>
import * as api from 'src/api'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    },
    loading: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      listData: [],
      // 分页信息
      page: {
        size: 15,
        total: '',
        page: 1,
        rows: 1
      }
    }
  },
  computed: {
    // 是否显示加载更多
    showLoadmore () {
      if (this.page.total > this.page.size && this.page.rows > this.page.page) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    openDetail (id) {
      this.$emit('openDetail', 'opportunityApi', id)
    },
    getList () {
      let url = '/opportunityApi/getCustomerOpportunity.html'
      let params = {
        customerId: this.id,
        page: this.page.page,
        pageSize: this.page.size
      }
      api.post(url, params, (data) => {
        this.page.total = data.pageHelper.rowsCount
        this.page.rows = data.pageHelper.pageTotal

        // 通过page.page来判断当前是刷新还是下拉加载更多
        if (this.page.page === 1) {
          this.listData = data.result
        } else {
          this.listData = this.listData.concat(data.result)
        }
      })
    },
    // 加载更多
    loadmore () {
      this.page.page++
      this.getList()
    }
  },
  watch: {
    loading () {
      if (this.page.rows > this.page.page) {
        this.loadmore()
      }
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../../assets/less/variable.less';
  .sale-opportunity {
    .item {
      padding: 15px 0;
      border: 1px solid #e5ecf7;
      border-radius: 2px;
      position: relative;
      margin-bottom: 15px;
      .title {
        padding-left: 15px;
      }
      .desc {
        font-size: 0;
        margin-top: 10px;
        .text {
          display: inline-block;
          font-size: 13px;
          line-height: 1;
          padding: 0 15px;
          color: @light-gray;
          border-right: 1px solid @light-gray;
          &:last-child {
            border-right-width: 0;
          }
        }
      }
      .status {
        position: absolute;
        right: 15px;
        top: 15px;
        font-size: 13px;
        color: #6a82a4;
      }
      &.center {
        line-height: 3;
        text-align: center;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// sale-opportunity.vue?2bee9f97